import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=67fccb57&scoped=true"
import script from "./carousel.vue?vue&type=script&lang=js"
export * from "./carousel.vue?vue&type=script&lang=js"
import style0 from "./carousel.vue?vue&type=style&index=0&id=67fccb57&prod&lang=scss"
import style1 from "./carousel.vue?vue&type=style&index=1&id=67fccb57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fccb57",
  null
  
)

export default component.exports